// frontend/src/utils/fontUtils.js

/**
 * Dynamically injects a @font-face rule for a custom font.
 * Only injects if a fontUrl is provided and the style tag doesn't already exist.
 * @param {string} fontFamily - The CSS font-family name to use.
 * @param {string|null} fontUrl - The URL to the font file. If null, assumes a system font.
 * @param {string} format - The format of the font file (e.g., 'woff2', 'truetype').
 */
export const applyCustomFont = (rawFontFamily, fontUrl, format) => {
  if (!fontUrl || !rawFontFamily || !format) {
    // If no fontUrl, rawFontFamily, or format is provided, assume it's a system font or Google Font already loaded
    // No need to inject @font-face rule dynamically
    return;
  }

  // Clean the name: remove extension and replace underscores/hyphens with spaces
  const fontFamily = rawFontFamily.replace(/\.[^/.]+$/, "").replace(/[_-]/g, " ");

  // Create a unique ID for the style tag to prevent duplicates
  const styleId = `font-style-${fontFamily.replace(/\s+/g, '-')}`; 

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
      @font-face {
        font-family: '${fontFamily}';
        src: url('${fontUrl}') format('${format}');
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
    console.log(`Injected @font-face for: ${fontFamily} from ${fontUrl}`);
  }
};
